module.exports = __webpack_public_path__ + "static/boarding-9aaec7fc7d217252159fffed12693620.jpg";